import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/Card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/Table";
import SplineChart from "./component/SplineChart";
import CardComponent from "./component/CardComponent";
import useDocumentTitle from "@/hooks/UseDocumentTitle";
import SimpleBarChart from "./component/BarChart";
import { BarChart } from 'recharts';

const Dashboard = () => {
  useDocumentTitle("Dashboard");
  return (
    <div className="grid gap-6 py-6 px-3 2xl:!max-w-[1400px] mx-auto ">
      {/* dashborad tiles */}
      <CardComponent />

      <div className="grid xlg:grid-cols-2 xlg:gap-x-6 px-4 gap-y-4">
        {/* dashborad graphs  */}
        <SimpleBarChart />
        <SplineChart />
      </div>

      {/* client table */}
      <div className="px-4">
        <Card>
          <CardHeader>
            <CardTitle className="text-2xl font-semibold">Clients</CardTitle>
            <CardDescription className="pt-1 text-gray-400 ">
              <i className="fa-solid text-green-400 fa-circle-check"></i>
              <span className="ml-2 text-gray-400 font-semibold text-base">
                Active Client
              </span>{" "}
              This month.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Table className="w-full">
              <TableHeader>
                <TableRow>
                  <TableHead>Order</TableHead>
                  <TableHead>Customer</TableHead>
                  <TableHead>Date</TableHead>
                  <TableHead>Total</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                <TableRow>
                  <TableCell>#3210</TableCell>
                  <TableCell>Olivia Martin</TableCell>
                  <TableCell>February 20, 2022</TableCell>
                  <TableCell>$42.25</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>#3209</TableCell>
                  <TableCell>Ava Johnson</TableCell>
                  <TableCell>January 5, 2022</TableCell>
                  <TableCell>$74.99</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>#3204</TableCell>
                  <TableCell>Michael Johnson</TableCell>
                  <TableCell>August 3, 2021</TableCell>
                  <TableCell>$64.75</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Dashboard;
